import { getTransformObject } from '~/shared/photos/transforms'
import { CampsitesPhotoGallery, PhotoTransforms } from './types'

export class AjaxCampsitePhotosRepository {
  getAjaxUrl(lang: string, campsiteIds: string[]) {
    const params = new URLSearchParams([
      ['campsite_ids', campsiteIds.join(',')],
      ['transformations', 'master_image'],
    ])
    const langPrefix = lang !== 'en-gb' ? `/${lang}` : ''
    return `/_/fallback${langPrefix}/pitchupphotos/campsite-gallery-photos/?${params.toString()}`
  }

  mapResults(response: AjaxResponse): CampsitesPhotoGallery {
    return Object.entries(response).reduce(
      (gallery, [campsiteId, campsitePhotos]) => {
        gallery[campsiteId] = {
          general: campsitePhotos.general.map(mapCampsitePhoto),
        }
        return gallery
      },
      {} as CampsitesPhotoGallery,
    )
  }
}

function mapCampsitePhoto({
  caption,
  url,
  title_by,
  title_attribution,
}: RawPhotoSnakeCase): CamelCasePhoto {
  return Object.freeze({
    url: getTransformObject<PhotoTransforms>('gallery', url.master_image),
    caption: title_by || caption || '',
    titleAttribution: title_attribution || '',
  })
}

interface ResponsePitchupPhoto {
  caption: string
  url: { master_image: string }
  title_by: string
}
interface ResponsePhotoGallery {
  general: ResponsePitchupPhoto[]
  categories: Record<string, ResponsePitchupPhoto[]>
}

type AjaxResponse = Record<string, ResponsePhotoGallery>

interface RawPhotoSnakeCase {
  url: { master_image: string }
  title_by: string
  caption?: string | null
  title_attribution?: string
}

interface CamelCasePhoto {
  url: PhotoTransforms
  caption: string
  titleAttribution: string
}
